



































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { OrganizationStep } from "@/classes/enums/OrganizationStep";
import OrganizationValidationRule from "@/classes/rules/OrganizationValidationRule";
import Organization from "@/classes/Organization";
import HIVETextField from "@/components/common/HIVETextField.vue";
import HIVEStatusDropDownList from "@/components/common/HIVEStatusDropDownList.vue";
import HIVEButton from "@/components/common/HIVEButton.vue";

@Component({
  components: {
    HIVETextField,
    HIVEStatusDropDownList,
    HIVEButton,
  },
})
export default class CreateUpdateOrganizationForm extends Vue {
  @Prop(Boolean) public complete: boolean;
  @Prop(Number) public step: number;
  @Prop(Object) public organization: Organization;

  private readonly organizationStep = OrganizationStep;
  private organizationValidationRule: OrganizationValidationRule = new OrganizationValidationRule();
  private imageData: File = null;

  private get isComplete() {
    return this.complete;
  }

  private get getStepNumber() {
    return this.step;
  }

  private get getOrganization() {
    return this.organization;
  }

  private get orgImageUri() {
    return this.$store.getters["organizations/getOrgImageUri"];
  }

  private set orgImageUri(val: string) {
    this.$store.commit("organizations/setOrgImageUri", val);
  }

  private get statusList() {
    return this.$store.getters["uicontrols/getStatusList"];
  }

  public onUpload() {
    if (this.imageData != null) {
      let formData = new FormData();
      formData.append("orgImage", this.imageData);
      this.$store.commit(
        "organizations/setOrgImageUri",
        URL.createObjectURL(this.imageData).toString()
      );
      this.$store.dispatch("organizations/uploadOrgImage", formData);
    }
  }

  private created() {
    this.$store.dispatch("uicontrols/getStatusListAsync");
    this.$store.dispatch("organizations/getOrganizationSettings");
    this.$store.commit(
      "organizations/setOrgImageUri",
      this.organization.imageUri
    );
  }
}
